module.exports = __webpack_public_path__ + "img/cate-3-7bb46e.png";